module.exports = __webpack_public_path__ + "static/media/92.4f4c7103.png";